'use client';

import { useEffect } from 'react';
import ErrorComponent from '@molecules/ErrorComponent/ErrorComponent';

/**
 * App Router Global Error page
 * Catches errors in root layout and provides minimal UI
 * Must include <html> and <body> tags as it replaces the root layout
 */
export default function GlobalError({
  error,
  reset: _reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (typeof window.newrelic !== 'undefined') {
      const { newrelic } = window;
      newrelic.noticeError(error);
    }
    console.error('App Router Global Error:', error);
  }, [error]);

  return (
    <html lang="sv">
      <body>
        <ErrorComponent errorCode={500} />
      </body>
    </html>
  );
}
